module.exports = __webpack_public_path__ + "9aeb7f7ba2e805eeae05ad5d0a9ae4a3.png";